import { z } from 'zod'
import { getDuplicatesRefinement } from 'src/util/src/zod'
import { WithSubscriberCountEstimateSchema } from '../../Social/models/WithSubscriberCountEstimate'
import { SocialChannelSchema, SocialChannelUidSchema } from '../../Social/models/SocialChannel'

export const GameSocialChannelSchema = SocialChannelSchema.extend(WithSubscriberCountEstimateSchema.shape)

export const GameSocialChannelsSchema = z.array(GameSocialChannelSchema)
  .superRefine(getDuplicatesRefinement('GameSocialChannel', parseGameSocialChannelUid))

export const GameSocialChannelUidSchema = SocialChannelUidSchema

export type GameSocialChannel = z.infer<typeof GameSocialChannelSchema>

export type GameSocialChannelUid = z.infer<typeof GameSocialChannelUidSchema>

export function parseGameSocialChannel(channel: GameSocialChannel): GameSocialChannel {
  return GameSocialChannelSchema.parse(channel)
}

export function parseGameSocialChannels(channels: GameSocialChannel[]): GameSocialChannel[] {
  return GameSocialChannelsSchema.parse(channels)
}

export function parseGameSocialChannelUid(channelUid: GameSocialChannelUid): GameSocialChannelUid {
  return GameSocialChannelUidSchema.parse(channelUid)
}
